import { Component, Input, Output, OnChanges, OnInit, SimpleChanges, EventEmitter } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Asset } from '@shared/models/asset.model';
import { AssetType } from '@shared/models/assetType.model';
import { Course } from '@shared/models/course.model';
import { CoursesAPIService } from '@shared/services/coursesApi.service';
import { SupervisorService } from '@shared/services/supervisor.service';
import { from } from 'rxjs';
import { filter, mergeMap, switchMap } from 'rxjs/operators';

@Component({
  selector: 'simulation-main-settings',
  templateUrl: './simulation-main-settings.component.html',
  styleUrls: ['./simulation-main-settings.component.scss']
})
export class SimulationMainSettingsComponent implements OnInit, OnChanges {
  @Input() course: Course;
  mainSettingsForm: FormGroup;
  AT = AssetType;

  @Output() courseChanged = new EventEmitter<Course>();

  constructor(
    private _courseApiService: CoursesAPIService,
    private _supervisorService: SupervisorService
  ) {
    this.mainSettingsForm = new FormGroup({
      title: new FormControl('', { validators: [Validators.required, Validators.maxLength(50)], updateOn: 'blur' }),
      description: new FormControl('', { updateOn: 'blur' })
    });
  }

  ngOnInit(): void {
    this.mainSettingsForm.valueChanges.pipe(
      mergeMap(() => from(Object.entries(this.mainSettingsForm.controls))),
      filter(([label, control]: [string, FormControl]) => control.dirty),
      switchMap(([label, control]: [string, FormControl]) => {
        control.markAsPristine();
        return this._courseApiService.patchCourse(this.course.id, { op: 'replace', path: label, value: control.value });
      })
    ).subscribe((course: Course) => {
      this.courseChanged.emit(course);
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['course'] && !!changes['course'].currentValue) {
      this.mainSettingsForm.reset({
        title: this.course.title,
        description: this.course.description
      });
    }
  }

  toggleGeneratePoster(enabled: boolean) {
    this._courseApiService.patchCourse(this.course.id, { op: 'replace', path: `information.autoGeneratePoster`, value: enabled })
      .subscribe((course) => {
        this._supervisorService.triggerGeneratePoster(course);
        this.course.information = course.information;
      });
  }

  updatePostermedia(asset: Asset) {
    this._courseApiService.updateCourse(this.course.id, { postermedia_id: asset.id }, false)
      .subscribe((course) => {
        this.course = course;
      });
  }
}
